import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {ClaimResponse, PostClaim} from './types';
import type {ClaimAccessType} from '@deezer/next/features/ClaimAccess/types';
import type {QueryFormData} from '@deezer/next/features/ClaimAccess/queryTypes';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';
import type {Release} from '@deezer/next/services/api/Starmania/requests/album/types';

const {get, post} = requestWrapper;

const requests = {
	getClaims: () => get<ClaimResponse>(endpoints.claims),
	denyClaims: (claimId: number) =>
		requestWrapper.delete(endpoints.denyClaim(claimId)),
	postClaim: (data: QueryFormData, claimAccessType: ClaimAccessType) =>
		post<PostClaim>(endpoints.claim(claimAccessType.toLowerCase()), data),
	getDiscographies: (id: string) =>
		get<DataResponseWrapper<Release[], {enabled: boolean}>>(
			endpoints.artistDiscographies(id),
		),
};

export default requests;
